import React, { useEffect, useState } from "react"
import { Button, Form, FormControl, FormGroup, Modal } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { fetchTenantEmployees } from "../app/actions"

const SignInToTenantModal = ({show, tenant, onHide}) => {
    const [selectedApplication, setSelectedApplication] = useState("m")
    const [selectedEmployee, setSelectedEmployee] = useState("")
    const [selectedRole, setSelectedRole] = useState("admin")
    const tenantEmployees = useSelector(store => store.app.tenantEmployees)
    const dispatch = useDispatch()

    useEffect(()=>{
        if(tenant) {
            dispatch(fetchTenantEmployees(tenant.DB_NAME))
        }
    }, [tenant])

    useEffect(()=>{
        setSelectedEmployee("")
    }, [show])

    const handleApplicationChange = (e) => {
        setSelectedApplication(e.target.value)
    }

    const handleRoleChange = (e) => {
        setSelectedRole(e.target.value)
    }

    const handleChange = (e) => {
        setSelectedEmployee(e.target.value)
    }

    let loginLink = ""
    if(tenant) {
        if(selectedApplication === "admin") {
            loginLink = `${process.env.REACT_APP_ADMINWEBB_URL}?employee=${selectedEmployee}&backend=${tenant.DB_NAME}&role=${selectedRole}`
        } else if(selectedApplication === "m") {
            loginLink = `${process.env.REACT_APP_MOBILWEBB_URL}login/as/${selectedEmployee}/${tenant.DB_NAME}/${selectedRole}`
        }
    }

    return <Modal show={show} onHide={onHide}>
        <Modal.Header>
            <h4>Sign in as</h4>
        </Modal.Header>
        <Modal.Body>
            <FormGroup>
                <Form.Label>
                    Application
                </Form.Label>
                <div>
                    <Form.Check
                        inline
                        id="adminwebbOption"
                        type="radio"
                        name="application"
                        label="Adminwebb"
                        value="admin"
                        checked={selectedApplication === "admin"}
                        onChange={handleApplicationChange}
                    />
                    <Form.Check
                        inline
                        id="mobilwebbOption"
                        type="radio"
                        name="application"
                        label="app.mygimo.se"
                        value="m"
                        checked={selectedApplication === "m"}
                        onChange={handleApplicationChange}
                    />
                </div>
            </FormGroup>
            <FormGroup>
                <Form.Label>
                    Tenant Employee
                </Form.Label>
                <FormControl as="select" value={selectedEmployee} onChange={handleChange}>
                    <option value={""}>Pick employee</option>
                    {tenantEmployees && tenantEmployees.map(employee => {
                        return <option key={employee.id} value={employee.id}>
                            #{employee.id} {employee.first_name} {employee.last_name}
                        </option>
                    })}
                </FormControl>
            </FormGroup>
            <FormGroup>
                <Form.Label>
                    With role
                </Form.Label>
                <div>
                    <Form.Check
                        inline
                        id="adminOption"
                        type="radio"
                        name="role"
                        label="Admin"
                        value="admin"
                        checked={selectedRole === "admin"}
                        onChange={handleRoleChange}
                    />
                    <Form.Check
                        inline
                        id="userOption"
                        type="radio"
                        name="role"
                        label="User"
                        value="user"
                        checked={selectedRole === "user"}
                        onChange={handleRoleChange}
                    />
                </div>
            </FormGroup>
        </Modal.Body>
        <Modal.Footer>
            <Button onClick={onHide} variant="default">Cancel</Button>
            <Button as={"a"} target={"_blank"} href={loginLink} disabled={!selectedEmployee}>Sign in</Button>
        </Modal.Footer>
    </Modal>
}

export default SignInToTenantModal